import React from 'react'
import PanelContainer from 'containers/panel/subreseller/panel-container'

const MainPage = () => {
  return (
    <PanelContainer />
  )
}

export default MainPage